import { ColumnTable } from '@octano/global-ui';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const dictPrefix = 'financialPortal.currentAccount.tabs.paymentHistory.table';

const formatDate = (value: unknown) => {
  if (!value) return '-';
  const d = dayjs(value as string);
  return d.isValid() ? d.utc().format('DD/MM/YYYY') : '-';
};

export default function useColumns(): ColumnTable<any>[] {
  const { t } = useTranslation();

  const translateOrFallback = (path: string, value: unknown) => {
    if (value == null || value === '') return '-';
    return t(`${path}.${value}`, { defaultValue: String(value) });
  };

  return [
    {
      columnName: 'paymentDate',
      headerText: t(`${dictPrefix}.paymentDate`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ value }) => formatDate(value),
    },
    {
      columnName: 'paymentType',
      headerText: t(`${dictPrefix}.paymentType`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ value }) =>
        translateOrFallback('paymentHub.paymentsTable.types', value),
    },
    {
      columnName: 'paymentChannel',
      headerText: t(`${dictPrefix}.paymentChannel`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ value }) =>
        translateOrFallback('paymentHub.paymentsTable.origins', value),
    },
    {
      columnName: 'voucherId',
      headerText: t(`${dictPrefix}.voucherId`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'transactionCode',
      headerText: t(`${dictPrefix}.transactionCode`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'paidBy',
      headerText: t(`${dictPrefix}.paidBy`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
  ];
}
